/**
 * Key-value persistence.
 *
 * The panel is browser-only, so this is `localStorage` behind the same interface the
 * member app wraps around Capacitor Preferences. Every call is guarded: storage can
 * be unavailable (Safari private mode), and losing a preference must never take the
 * app down with it.
 */

export const StorageKey = {
  Token: "elyxeer-admin.token",
  Locale: "elyxeer-admin.locale",
} as const;

export type StorageKey = (typeof StorageKey)[keyof typeof StorageKey];

export async function getItem(key: StorageKey): Promise<string | null> {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export async function setItem(key: StorageKey, value: string): Promise<void> {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Storage may be unavailable; the in-memory session still works for this run.
  }
}

export async function removeItem(key: StorageKey): Promise<void> {
  try {
    window.localStorage.removeItem(key);
  } catch {
    // Ignore — see above.
  }
}
